<template>
  <vl-properties-list>
    <vl-properties-label>{{ $t('productEntityDataMapping.detail.id') }}</vl-properties-label>
    <vl-properties-data>
      {{ props.detail.id }}
    </vl-properties-data>
    <vl-properties-label>{{ $t('productEntityDataMapping.detail.fromEntity') }}</vl-properties-label>
    <vl-properties-data>
      {{ getEntityLabel(props.detail.fromEntity) }}
    </vl-properties-data>
    <vl-properties-label>{{ $t('productEntityDataMapping.detail.toEntity') }}</vl-properties-label>
    <vl-properties-data>
      {{ getEntityLabel(props.detail.toEntity) }}
    </vl-properties-data>
  </vl-properties-list>
  <vl-grid v-vl-spacer:top.medium>
    <vl-column>
      <ProductEntityDataMappingAttributesRead :detail="detail" />
    </vl-column>
  </vl-grid>
</template>

<script lang="ts" setup>
import { ProductEntityDataMappingDetailDto, ProductEntityDetailDto } from '@/api/backoffice/clients';
import ProductEntityDataMappingAttributesRead from './ProductEntityDataMappingAttributesRead.vue';

const props = defineProps<{
  detail: ProductEntityDataMappingDetailDto;
}>();

const getEntityLabel = (entity: ProductEntityDetailDto): string => {
  return entity ? `[${entity.id}] ${entity.label}` : '-';
};
</script>
